<script setup lang="ts">
definePageMeta({
  alias: ['/restaurantes/:citySlug'],
  pageType: 'RESTAURANT_LIST_CITY',
})

const route = useRoute()
const citySlug = route.params.citySlug
let cityName = ''

if (citySlug && typeof citySlug === 'string') {
  cityName = citySlug.replace(/-/g, ' ').toLowerCase()
}
</script>

<template>
  <RestaurantView :city-name="cityName" />
</template>
